export interface ICategoryType {
  name: string
  value: CategoryType
}

export enum CategoryType {
  None = 0,
  TestReport = 1,
  ClassificationReport = 2,
  ApplicationForm = 3,
  Label = 4,
  Manual = 5,
  OtherSupportingDocuments = 6,
  FactoryInspectionReport = 7,
  MarketSurveillanceReport = 8,
  MSComplianceLetter = 9,
  MSSamplingForm = 10,
  MSEvaluationForm = 11,
  MSAdditionalSurveillance = 12,
  EvaluationReport = 13,
  TestReference = 14,
  Classification = 15,
  Assessment = 16,
  Eta = 17,
  Ukta = 18,
  Compliance = 19,
  InitialFpcAssessmentReport = 20,
  FpcAssessmentReport = 21,
  AuditTesting = 22,
  SupportingDoc = 23,
}

export const TestReportCategoryList: ICategoryType[] = [
  {
    name: 'Test Report',
    value: CategoryType.TestReport,
  },
  {
    name: 'Classification Report',
    value: CategoryType.ClassificationReport,
  },
]

export const R2CCategoryList: ICategoryType[] = [
  {
    name: 'Application Form',
    value: CategoryType.ApplicationForm,
  },
  {
    name: 'Label',
    value: CategoryType.Label,
  },
  {
    name: 'Manual',
    value: CategoryType.Manual,
  },
  {
    name: 'Other Supporting Documents',
    value: CategoryType.OtherSupportingDocuments,
  },
  {
    name: 'Evaluation Report',
    value: CategoryType.EvaluationReport,
  },
  {
    name: 'Test Reference',
    value: CategoryType.TestReference,
  },
  {
    name: 'Classification',
    value: CategoryType.Classification,
  },
  {
    name: 'Assessment',
    value: CategoryType.Assessment,
  },
  {
    name: 'ETA',
    value: CategoryType.Eta,
  },
  {
    name: 'UKTA',
    value: CategoryType.Ukta,
  },
  {
    name: 'Compliance',
    value: CategoryType.Compliance,
  },
  {
    name: 'Initial FPC Assessment Report',
    value: CategoryType.InitialFpcAssessmentReport,
  },
]

export const InspectionCategoryList: ICategoryType[] = [
  {
    name: 'Factory Inspection Report',
    value: CategoryType.FactoryInspectionReport,
  },
  {
    name: 'Market Surveillance Report',
    value: CategoryType.MarketSurveillanceReport,
  },
  {
    name: 'MS Compliance Letter',
    value: CategoryType.MSComplianceLetter,
  },
  {
    name: 'MS Sampling Form',
    value: CategoryType.MSSamplingForm,
  },
  {
    name: 'MS Evaluation Form',
    value: CategoryType.MSEvaluationForm,
  },
  {
    name: 'MS Additional Surveillance',
    value: CategoryType.MSAdditionalSurveillance,
  },
  {
    name: 'FPC Assessment Report',
    value: CategoryType.FpcAssessmentReport,
  },
  {
    name: 'Audit Testing',
    value: CategoryType.AuditTesting,
  },
  {
    name: 'Supporting Doc',
    value: CategoryType.SupportingDoc,
  },
]
